import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaWhatsapp, FaTimes, FaPhone } from "react-icons/fa";
import {
  HELPDESK_PHONE_TEL,
  WHATSAPP_NUMBER,
} from "../utils/clinicContact";
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = WHATSAPP_NUMBER;
    const message =
      "Hello! I'm interested in learning more about SATYA HEART CLINIC's cardiac care services. Could you please provide me with information about consultation options and available treatments?";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  const handleCallClick = () => {
    window.location.href = `tel:${HELPDESK_PHONE_TEL}`;
  };

  return (
    <div className="whatsapp-container">
      {/* Main WhatsApp Button */}
      <motion.button
        className="whatsapp-button"
        onClick={toggleExpanded}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: "spring", stiffness: 260, damping: 20 }}
      >
        <FaWhatsapp />
      </motion.button>

      {/* Expanded Options */}
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            className="whatsapp-expanded"
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            transition={{ duration: 0.2 }}
          >
            {/* WhatsApp Option */}
            <motion.button
              className="expanded-option whatsapp-option"
              onClick={handleWhatsAppClick}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaWhatsapp />
              <span>WhatsApp</span>
            </motion.button>

            {/* Phone Option */}
            <motion.button
              className="expanded-option phone-option"
              onClick={handleCallClick}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPhone />
              <span>Call Now</span>
            </motion.button>

            {/* Close Button */}
            <motion.button
              className="expanded-option close-option"
              onClick={toggleExpanded}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaTimes />
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Tooltip */}
      <AnimatePresence>
        {!isExpanded && (
          <motion.div
            className="whatsapp-tooltip"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ delay: 0.5 }}
          >
            <span>Need help? Chat with us!</span>
            <div className="tooltip-arrow"></div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default WhatsAppButton;
